import React, { FC } from 'react';
import { LoadIndicator } from '../common/LoadIndicator';
import { FetchBundleTotalsApiResponse } from '../../api/bundles/fetchBundleDetailTotals';
import { useTranslation } from 'react-i18next';
import FormatCurrency from '../utils/formatCurrency';

type Props = {
    readonly bundle: FetchBundleTotalsApiResponse & { price?: number };
    readonly isLoading?: boolean;
};

const BundleDiscountLine: FC<Props> = ({ bundle, isLoading }) => {
    const { t } = useTranslation();
    const hasSavedPercentage = bundle.savedPercentage && bundle.savedPercentage > 0;
    const minSavedPercent = hasSavedPercentage ? 1 : 0;
    const savedPercent = Math.round((bundle.savedPercentage ?? 0) / 100);
    const savingPercent = Math.max(minSavedPercent, savedPercent); // when saving is rounded to 0% show 1% instead
    const crossedPrice = t('numberFormat.numberWithCurrencySymbol', {
        val: FormatCurrency.convertIntegerToCurrencyFormat(bundle.basePrice ?? bundle.price),
        currencySymbol: FormatCurrency.mapCurrencyToSymbol(bundle.currency)
    });

    return (
        <div className="bndl-saved-price">
            {bundle.basePrice || bundle?.price ? (
                isLoading ? (
                    <LoadIndicator />
                ) : (
                    <div className="prices">
                        <span>
                            {t('reserveReports.reserveReport.viewReport.save', {
                                amount: t('numberFormat.numberWithCurrencySymbol', {
                                    val: FormatCurrency.convertIntegerToCurrencyFormat(bundle.savedValue),
                                    currencySymbol: FormatCurrency.mapCurrencyToSymbol(bundle.currency)
                                }),
                                percentile: savingPercent
                            })}
                        </span>{' '}
                        <span className="crossed">{crossedPrice}</span>
                    </div>
                )
            ) : null}
        </div>
    );
};

export default BundleDiscountLine;
